package empiresmp.feature.votes.presentation

import kotlinx.browser.localStorage
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlin.js.Date
import kotlin.time.Duration.Companion.hours
import kotlin.time.Duration.Companion.milliseconds

class VotesComponent {
    private fun getIsClickedBefore(key: Any) = let {
        val now = Date.now().milliseconds
        val date = localStorage.getItem(key.toString())?.toLongOrNull()?.milliseconds ?: 0.milliseconds
        now - date < 16.hours
    }

    private fun buildUrls(): List<VoteUrl> {
        return listOf(
            VoteUrl.MinecraftRating(
                id = 290898,
                name = "FrontierSmp",
            ),
            VoteUrl.MinecraftRating(
                id = 295288,
                name = "WildernessSmp"
            ),
            VoteUrl.MinecraftRating(
                id = 295287,
                name = "EndureCraft"
            ),
            VoteUrl.MinecraftRating(
                id = 293843,
                name = "ExploreSmp"
            ),
            VoteUrl.MinecraftRating(
                id = 290896,
                name = "LongExile"
            ),
            VoteUrl.MinecraftRatingProject(
                name = "Проект сервера",
                url = "https://minecraftrating.ru/projects/empireprojekt/"
            ),
            VoteUrl.HotMc(
                id = 200387,
                name = "FrontierSurvival"
            ),
            VoteUrl.HotMc(
                id = 258775,
                name = "WildernessSmp"
            ),
            VoteUrl.HotMc(
                id = 258776,
                name = "EndureCraft"
            ),
        )
    }

    private val _urls = MutableStateFlow(buildUrls())
    val urls: StateFlow<List<VoteUrl>> = _urls.asStateFlow()

    private fun updateList() {
        _urls.update { urls ->
            urls.toList().map { voteUrl ->
                when (voteUrl) {
                    is VoteUrl.HotMc -> voteUrl.copy(isClickedBefore = getIsClickedBefore(voteUrl.url))
                    is VoteUrl.MinecraftRating -> voteUrl.copy(isClickedBefore = getIsClickedBefore(voteUrl.url))
                    is VoteUrl.MinecraftRatingProject -> voteUrl.copy(isClickedBefore = getIsClickedBefore(voteUrl.url))
                }
            }
        }
    }

    fun onClicked(voteUrl: VoteUrl) {
        localStorage.setItem(voteUrl.url, Date.now().toLong().toString())
        updateList()
    }

    init {
        updateList()
    }

    sealed interface VoteUrl {
        val name: String
        val url: String
        val hasAward: Boolean
        val isClickedBefore: Boolean

        data class MinecraftRating(
            val id: Long,
            override val name: String,
            override val url: String,
            override val isClickedBefore: Boolean = false
        ) : VoteUrl {
            constructor(
                id: Long,
                name: String,
            ) : this(
                id = id,
                name = name,
                url = "https://minecraftrating.ru/vote/$id/",
            )

            override val hasAward: Boolean = false
        }

        data class HotMc(
            val id: Long,
            override val name: String,
            override val url: String,
            override val isClickedBefore: Boolean = false
        ) : VoteUrl {
            constructor(id: Long, name: String) : this(
                id = id,
                name = name,
                url = "https://hotmc.ru/minecraft-server-$id"
            )

            override val hasAward: Boolean = true
        }

        data class MinecraftRatingProject(
            override val name: String,
            override val url: String,
            override val isClickedBefore: Boolean = false
        ) : VoteUrl {
            override val hasAward: Boolean = true
        }
    }
}
